import { render } from "./PaymentHealth.vue?vue&type=template&id=c17395a6"
import script from "./PaymentHealth.vue?vue&type=script&lang=js"
export * from "./PaymentHealth.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__